import { useSelector, useDispatch } from 'react-redux';
import { set, unSet } from '../store/userProfile/userProfileSlice';
import {
  clearOnLocalStorage,
  getFromLocalStorage,
  setOnLocalStorage,
} from '../utils/user-profile';
import { useEffect } from 'react';
import apiService from '../axios/apiService';

export const useUserProfile = () => {
  const userProfile = useSelector((state) => state?.rootReducer?.userProfile?.value);
  const dispatch = useDispatch();

  const fetchUserProfile = async () => {
    const profile = await apiService.getUserProfile();
    if (profile) {
      setUserProfile(profile);
    }
  };

  const getUserProfile = () => getFromLocalStorage();

  const setUserProfile = (userProfile) => {
    if (!userProfile) return;
    dispatch(set(userProfile));
    setOnLocalStorage(userProfile);
  };
  const unSetUserProfile = () => {
    dispatch(unSet());
    clearOnLocalStorage();
  };

  useEffect(() => {
    if (!userProfile) {
      const profile = getUserProfile();
      if (profile) {
        setUserProfile(profile);
      } else {
        fetchUserProfile();
      }
    }
  }, [userProfile]);

  return {
    userProfile,
    setUserProfile,
    unSetUserProfile,
    getUserProfile,
  };
};
